import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSnackbar from './NotificationSnackbar';
export class ErrorNotification extends Component {
  state = {
    display: true
  };

  _handleNotificationClose = () => {
    this.setState(
      {
        display: false
      },
      this.props.onClose
    );
  };

  static propTypes = {
    message: PropTypes.string.isRequired
  };
  render() {
    return (
      <NotificationSnackbar
        message={this.props.message}
        open={this.state.display}
        handleSnackbarClose={this._handleNotificationClose}
      />
    );
  }
}

export default ErrorNotification;
